export function addCurrencySymbol(amountValue, currencySymbol) {
    if (amountValue !== undefined && amountValue !== null) {
        if (amountValue[0] === "-") {
            return `-${currencySymbol}${amountValue.substring(1)}`;
        }
        return `${currencySymbol}${amountValue}`;
    }
    return "";
}
